import { ComponentType, ReactNode, createElement, memo } from 'react';

import clsx from 'clsx';

import css from './CardHeader.module.css';

import { WithClassName } from 'v2/types';

interface CardHeaderProps extends WithClassName {
  title: string;
  icon: ComponentType<WithClassName>;
  subheader?: boolean;
  actions?: ReactNode;
}

export const CardHeader = memo<CardHeaderProps>(({ className, title, icon, subheader, actions }) => (
  <h4 className={clsx(css.cardHeader, subheader && css.smaller, className)}>
    <span className={css.cardHeaderTitle}>
      {createElement(icon, { className: clsx(css.cardHeaderIcon, subheader && css.smaller) })} {title}
    </span>
    {actions && <span className={css.cardHeaderActions}>{actions}</span>}
  </h4>
));

CardHeader.displayName = 'CardHeader';
